import CloseCircleIcon from "../atoms/images/CloseCircleIcon";
import { useDispatch } from "react-redux";
import { setIsOn } from "../../features/voiceAssistantSlice";
import { closeWS, handleInterrupt } from "../../services/voiceService";

export const VoiceAssistantActionContainer = () => {
    const dispatch = useDispatch();

    return (
        <div className="va-button-container">
            <div
                onClick={() => {
                    handleInterrupt();
                    closeWS();
                    dispatch(setIsOn(false));
                }}
            >
                <CloseCircleIcon />
            </div>
        </div>
    );
};
